import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Editorial", href: "/#editorial" },
  { label: "Directory", href: "/#directory" },
  { label: "Issues", href: "/#issues" },
  { label: "Advertise", href: "/#advertise" },
];

const Nav = ({ solid = false }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const dark = solid || scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        dark
          ? "bg-white/85 backdrop-blur-xl border-b border-black/10"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-8 lg:px-12 flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center"
        >
          <img
            src="/logo-tj.png"
            alt="Texas Journal"
            className={`h-5 md:h-7 w-auto object-contain transition-[filter] duration-300 ${dark ? "invert" : ""}`}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`link-underline font-accent uppercase text-xs tracking-[0.2em] transition-colors ${
                dark ? "text-[#0a0a0a]" : "text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#advertise"
            data-testid="nav-cta"
            className={`font-accent uppercase text-xs tracking-[0.2em] px-5 py-2.5 border transition-all duration-300 ${
              dark
                ? "border-black bg-black text-white hover:bg-white hover:text-black"
                : "border-white text-white hover:bg-white hover:text-black"
            }`}
          >
            Be Featured
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className={`md:hidden ${dark ? "text-black" : "text-white"}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-black/10 px-6 py-8 flex flex-col gap-6"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              className="font-accent uppercase text-sm tracking-[0.2em] text-[#0a0a0a]"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};

export default Nav;
